import reduxUtils from 'app/shared/utils/reduxUtils';
import constants from 'app/shared/constants/ConstantsBundle';

export type ReviewState = {
  isSubmitting: boolean;
  isSubmitted: boolean;
  error: string | null;
};

const initState = (): ReviewState => ({
  isSubmitting: false,
  isSubmitted: false,
  error: null,
});

const mappedActions = {
  [constants.SUBMIT_REVIEW_REQUEST]: (state: ReviewState): ReviewState => ({
    ...state,
    isSubmitting: true,
    isSubmitted: false,
    error: null,
  }),
  [constants.SUBMIT_REVIEW_SUCCESS]: (state: ReviewState): ReviewState => ({
    ...state,
    isSubmitting: false,
    isSubmitted: true,
    error: null,
  }),
  [constants.SUBMIT_REVIEW_FAILURE]: (state: ReviewState, action: { payload: string }): ReviewState => ({
    ...state,
    isSubmitting: false,
    isSubmitted: false,
    error: action.payload,
  }),
  [constants.SUBMIT_REVIEW_RESET]: (state: ReviewState): ReviewState => ({
    ...state,
    isSubmitting: false,
    isSubmitted: false,
    error: null,
  }),
};

const review = reduxUtils.createReducer<ReviewState>(mappedActions, initState());

export default review;
